import { Autoplay, Navigation, Scrollbar } from 'swiper';
import { swiperOnResize } from '../../utils/swiperOnResize.utils.js';

const initializedWrappers = new WeakSet();
const equalizersRegistry = new WeakMap();
const rowTopTolerance = 4;

const getBlogsSlides = (swiperEl) => {
  return Array.from(
    swiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide')
  );
};

const getBlogsSlideRows = (swiperEl) => {
  const slides = getBlogsSlides(swiperEl);
  const swiper = swiperEl.swiper;

  if (!slides.length) {
    return [];
  }

  if (swiper && !swiper.destroyed) {
    return [slides];
  }

  const rows = [];

  slides.forEach((slide) => {
    const top = slide.getBoundingClientRect().top;
    const existingRow = rows.find((row) => {
      return Math.abs(row.top - top) <= rowTopTolerance;
    });

    if (existingRow) {
      existingRow.slides.push(slide);
      existingRow.top = Math.min(existingRow.top, top);
      return;
    }

    rows.push({
      top,
      slides: [slide],
    });
  });

  return rows
    .sort((a, b) => a.top - b.top)
    .map((row) => row.slides);
};

const getBlogsTitleGroups = (swiperEl) => {
  const rows = getBlogsSlideRows(swiperEl);
  const groups = [];

  rows.forEach((row) => {
    const titles = row
      .map((slide) => slide.querySelector('.blog-card__title'))
      .filter(Boolean);

    if (titles.length) {
      groups.push(titles);
    }
  });

  return groups;
};

const setupBlogsTitleEqualizer = (swiperEl) => {
  const equalizer = equalizersRegistry.get(swiperEl);

  if (equalizer) {
    equalizer.refresh();
    return;
  }

  if (typeof window.lineTitlesFunc !== 'function') {
    return;
  }

  equalizersRegistry.set(
    swiperEl,
    window.lineTitlesFunc([], {
      getGroups: () => getBlogsTitleGroups(swiperEl),
    })
  );
};

const initBlogsSwiper = (scope = document) => {
  const blogsSwiperWr = scope.querySelectorAll('.blogs-swiper-wr');

  blogsSwiperWr.forEach((el) => {
    if (initializedWrappers.has(el)) {
      const swiperEl = el.querySelector('.swiper');

      if (swiperEl) {
        setupBlogsTitleEqualizer(swiperEl);
      }

      return;
    }

    const swiperEl = el.querySelector('.swiper');

    if (!swiperEl) {
      return;
    }

    const slidesCount = getBlogsSlides(swiperEl).length;

    if (!slidesCount) {
      return;
    }

    initializedWrappers.add(el);

    const scrollbarEl = el.querySelector('.swiper-scrollbar');
    const nextEl = el.querySelector('.swiper-button-next');
    const prevEl = el.querySelector('.swiper-button-prev');

    swiperOnResize('(max-width: 1023px)', swiperEl,
      {
        modules: [Autoplay, Navigation, Scrollbar],
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        scrollbar: scrollbarEl ? {
          el: scrollbarEl,
          draggable: true,
          dragSize: 'auto',
        } : undefined,
        navigation: nextEl && prevEl ? {nextEl, prevEl} : undefined,
      },
    );

    setupBlogsTitleEqualizer(swiperEl);
  });
};

initBlogsSwiper();
window.initBlogsSwiper = initBlogsSwiper;
